import { view } from "../../../views/mapView/MapView";
import ElevationLayer from "@arcgis/core/layers/ElevationLayer";
import Ground from "@arcgis/core/Ground";
import ElevationProfile from "@arcgis/core/widgets/ElevationProfile";
import ElevationProfileLineGround from "@arcgis/core/widgets/ElevationProfile/ElevationProfileLineGround";

export const ElevProfileVM = async (container,view) => {
  const worldElevation = new ElevationLayer({
    url: "https://www.ocgis.com/arcpub/rest/services/Elevation/oc_dem_1m_2018/ImageServer",
  });
  
  const elevProfileLineGround: any = new ElevationProfileLineGround({
    type: "ground",
    color: "#61d4a4",
    title: "Ground",
  } as any);
  const ground = new Ground({ layers: [worldElevation] });
  view.map.set("ground", ground);

  const elevationProfile = await view.when(() => {
    const widget = new ElevationProfile({
      container: container,
      view: view,
      unit: "imperial",
      profiles: [elevProfileLineGround],
      visibleElements: {
        chart: true,
        clearButton: true,
        settingsButton: true,
        legend: true,
        sketchButton: true,
        selectButton: false,
      },
    });

    return widget;
  });
  return elevationProfile;
};
